import { useUserSettings } from '../../../utils/use-user-settings';
import { isFeatureEnabled } from '../../../utils/feature-flags';
import DecomPolicyDrawerDetailsOld from './decom-policy-drawer-details-old';
import DecomPolicyDrawerDetails from './decom-policy-drawer-details';

export default function DecomPolicyDrawerDetailsPage() {
  const { features } = useUserSettings();
  const isDecomUiUpdateEnabled = isFeatureEnabled(
    'decommissioningUiUpdate',
    features
  );
  return isDecomUiUpdateEnabled ? (
    <DecomPolicyDrawerDetails />
  ) : (
    <DecomPolicyDrawerDetailsOld />
  );
}
